import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import { Pages } from 'modules/navigation/domain/enums/pages';
import { ChampionshipInfoForm } from 'modules/championship/ui/components/championship-form';
import InfoFormSkeleton from 'modules/championship/ui/components/championship-form/info-form-skeleton';
import { useOrganizer } from 'modules/organizer/ui/hooks/use-organizer';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes, useMatch } from 'react-router-dom';

import { useFeatureFlag } from 'shared/feature-flags';
import ChampionshipApplicationsPage from 'modules/teams/ui/pages/championship-applications-page';
import { ChampionshipStateData } from 'modules/championship/store/championship';
import { championshipIsLoadingSelector } from 'modules/championship/store/championship/selectors';
import { isChampionshipEditTabAvailable } from 'modules/championship/domain/utils/application-campaign-tab-availability';
import ChampionshipRulesForm from '../form-parts/rules';
import ChampionshipStagesRoutes from '../form-parts/stages/stages-routes';
import ChampionshipSymbolicTeams from '../form-parts/symbolic-teams/symbolic-teams';

type Props = {
  championship?: ChampionshipStateData;
};

const ChampionshipEditForm = (props: Props) => {
  const { info } = useOrganizer();
  const isCommon = useMatch({ path: `${Pages.CHAMPIONSHIPS.EDIT}/${ChampionshipEditTab.COMMON}` });
  const { championship } = props;
  const isChampionshipLoading = useSelector(championshipIsLoadingSelector);
  const isFlow1447 = useFeatureFlag('applicationsFlow1447');

  if (isCommon && (!info || isChampionshipLoading || !championship)) {
    return <InfoFormSkeleton showDeleteButton={true} />;
  }

  if (!info || !championship) {
    return null;
  }

  // Прямой адрес заявок/этапов/сборных в обход табов уводит на «Параметры»,
  // пока заявочная компания не заполнена и не сохранена — те же условия, что
  // гасят вкладки в `ChampionshipEditFormTabs`. Это часть IMGM-1447 и на `dev` её нет —
  // в легаси-ветке флага `applicationsFlow1447` роуты открыты всегда, как на проде.
  const redirectToRules = <Navigate to={Pages.CHAMPIONSHIPS.builders.edit(championship.id, ChampionshipEditTab.RULES)} replace />;
  const isTabAvailable = (tab: ChampionshipEditTab) => !isFlow1447 || isChampionshipEditTabAvailable(championship.settings, tab);

  return (
    <Routes>
      <Route path="rules" element={<ChampionshipRulesForm tournamentId={info!.id} championshipId={championship.id} />} />
      <Route
        path="applications/*"
        element={isTabAvailable(ChampionshipEditTab.TEAMS) ? <ChampionshipApplicationsPage championshipId={championship.id} /> : redirectToRules}
      />
      <Route
        path="steps/*"
        element={isTabAvailable(ChampionshipEditTab.STEPS) ? <ChampionshipStagesRoutes championship={championship} /> : redirectToRules}
      />
      <Route
        path="symbolic-teams"
        element={
          isTabAvailable(ChampionshipEditTab.SYMBOLIC_TEAMS) ? (
            <ChampionshipSymbolicTeams championshipId={championship.id} items={championship.symbolicTeams} />
          ) : (
            redirectToRules
          )
        }
      />
      <Route path="*" element={<ChampionshipInfoForm tournamentId={info!.id} championshipId={championship.id} />} />
    </Routes>
  );
};

export default ChampionshipEditForm;
